<template>
<div class='services-configuration-cell'>
  <div class='services-configuration-cell__content'>
    <service-icon v-for='serviceName in getAllServices'
                  :name='serviceName'
                  :key='serviceName'
                  class='services-configuration-cell__content__item'
    />
  </div>
</div>
</template>

<script>

import ServiceIcon from '@/components/common/ServiceIcon.vue';

export default {
  name: 'Services',
  components: { ServiceIcon },
  props: {
    hosts: {
      type: Array,
      required: true,
    },
  },
  computed: {
    getAllServices() {
      const servicesSet = new Set();
      this.hosts.forEach(host => {
        if (host?.providerData && host.providerData?.service && host.providerData.service.length > 0) {
          servicesSet.add(host.providerData.service);
        }
        if (host?.providerData && host.providerData?.services && host.providerData.services.length > 0) {
          host.providerData.services.forEach(serviceData => {
            if (serviceData?.service && serviceData.service.length > 0) {
              servicesSet.add(serviceData.service);
            }
          });
        }
      });
      return Array.from(servicesSet);
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.services-configuration-cell {
  display: flex;
  justify-content: center;
  margin-left: rem(-27);

  &__content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

    &__item {
      width: rem(30);
      height: rem(30);
      margin-left: $space-2;
      margin-bottom: $space-2;
      cursor: default;
    }
  }
}
</style>
